import React from "react";
import MuiBox from "@mui/material/Box";
import clsx from "clsx";

import { TypographyProps, VariantMap } from "./Typography.types";
import { useStyles } from "./Typography.styles";

const variantMapping: VariantMap = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  body1: "span",
  body2: "span",
  body3: "span",
  label1: "span",
  label2: "span",
  label3: "span",
};

function Typography(props: TypographyProps, ref: React.ForwardedRef<any>) {
  const {
    align,
    bullet,
    bulletColor,
    color,
    component: componentProp,
    className: classNameProp,
    children,
    display,
    fontWeight = "regular",
    id,
    label,
    noWrap,
    tone,
    variant = "body1",
    wordBreak,
    ...other
  } = props;

  const classes = useStyles(props);

  const component = componentProp || variantMapping[variant];

  const className = clsx(classNameProp, classes.root, classes[variant], {
    [classes.alignLeft]: align === "left",
    [classes.alignCenter]: align === "center",
    [classes.alignRight]: align === "right",
    [classes.displayBlock]: display === "block",
    [classes.displayInline]: display === "inline",
    [classes.displayInitial]: display === "initial",
    [classes.fontWeightRegular]: fontWeight === "regular",
    [classes.fontWeightSemiBold]: fontWeight === "semiBold",
    [classes.fontWeightBold]: fontWeight === "bold",
    [classes.noWrap]: noWrap,
    [classes.colorRedMain]: color === "red",
    [classes.colorRedLight]: color === "red" && tone === "light",
    [classes.colorRedDark]: color === "red" && tone === "dark",
    [classes.colorPrimaryMain]: color === "primary" && tone === "main",
    [classes.colorPrimaryLight]: color === "primary" && tone === "light",
    [classes.colorPrimaryDark]: color === "primary" && tone === "dark",
    [classes.colorYellowMain]: color === "yellow",
    [classes.colorYellowDark]: color === "yellow" && tone === "dark",
    [classes.colorGrey50]: color === "grey" && tone === 50,
    [classes.colorGrey100]: color === "grey" && tone === 100,
    [classes.colorGrey200]: color === "grey" && tone === 200,
    [classes.colorGrey300]: color === "grey" && tone === 300,
    [classes.colorGrey400]: color === "grey" && tone === 400,
    [classes.colorGrey500]: color === "grey" && tone === 500,
    [classes.colorGrey600]: color === "grey" && tone === 600,
    [classes.colorGrey700]: color === "grey" && tone === 700,
    [classes.colorGrey800]: color === "grey" && tone === 800,
    [classes.colorGrey900]: color === "grey" && tone === 900,
    [classes.colorWhite]: color === "white",
    [classes.bullet]: bullet,
    [classes.wordBreakAll]: wordBreak === "break-all",
  });

  return (
    <MuiBox
      {...other}
      // @ts-ignore
      ref={ref}
      id={id}
      className={className}
      component={component}
      aria-label={label}
    >
      {children}
    </MuiBox>
  );
}

export default React.forwardRef(Typography);
